// extracted by mini-css-extract-plugin
export default {"BreakpointFromMedium":"(min-width: 640px)","sectionWrapper":"G361e9a","sectionTitle":"G07f676","sectionSubTitle":"G3d6ade"};